// ARC-9: selection is engine-owned UI state, pruned when entities disappear, never serialized.
import type { Doc } from "../doc/entities";

export class SelectionSet {
  private ids = new Set<string>();
  private listeners = new Set<() => void>();

  subscribe(fn: () => void): () => void {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  }

  private notify(): void {
    for (const fn of this.listeners) fn();
  }

  get all(): ReadonlySet<string> {
    return this.ids;
  }

  get size(): number {
    return this.ids.size;
  }

  has(id: string): boolean {
    return this.ids.has(id);
  }

  set(ids: Iterable<string>): void {
    this.ids = new Set(ids);
    this.notify();
  }

  toggle(id: string): void {
    if (this.ids.has(id)) this.ids.delete(id);
    else this.ids.add(id);
    this.notify();
  }

  clear(): void {
    if (this.ids.size === 0) return;
    this.ids.clear();
    this.notify();
  }

  /** EC-DM-3: prune to still-existing ids after any doc change. */
  prune(doc: Doc): void {
    let changed = false;
    for (const id of this.ids) {
      if (!doc.entities[id]) {
        this.ids.delete(id);
        changed = true;
      }
    }
    if (changed) this.notify();
  }
}
